import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from './AxiosBaseQuery';
import { designsApi } from './DesignQuery';
import { API_SERVER_URL } from '@/constants/Config';

export const designsLocalApi = createApi({
  reducerPath: 'designsLocalApi',
  tagTypes: ['Revision'],
  baseQuery: axiosBaseQuery({
    baseUrl: API_SERVER_URL,
  }),
  endpoints: (build) => ({
    deleteDesign: build.mutation({
      query: ({ id, data }) => ({
        url: `api/design-groups/proof-item/${id}/designs`,
        method: 'DELETE',
        data,
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          if (arg.shouldInvalidate) {
            dispatch(designsApi.util.invalidateTags([{ type: 'Revision' }]));
            dispatch(designsApi.endpoints.getDesign.initiate({ id: arg.proofId }));
          }
        } catch {
          // Optionally handle error
        }
      },
    }),
  }),
});

export const { useDeleteDesignMutation: useDeleteDesignLocalMutation } = designsLocalApi;
